import Image from 'next/image';
import classNames from 'classnames';
import styles from './StoreBadgeBase.module.scss';

type StoreBadgeBaseProps = {
  dataTestId: string;
  height: number;
  noReferrer: boolean;
  className?: string;
  storeUrl: string;
  altText: string;
  src: string;
};

const StoreBadgeBase = ({ height, className = '', noReferrer, storeUrl, altText, src, dataTestId }: StoreBadgeBaseProps) => {
  return (
    <a href={storeUrl} target="_blank" rel={noReferrer ? 'noreferrer' : ''} data-testid={dataTestId}>
      <Image height={height} src={src} className={classNames(styles.baseClass, className)} alt={altText} />
    </a>
  );
};

export default StoreBadgeBase;
